var _classCallCheck = require("/vercel/workpath0/node_modules/@babel/runtime/helpers/classCallCheck");

var _inherits = require("/vercel/workpath0/node_modules/@babel/runtime/helpers/inherits");

var _possibleConstructorReturn = require("/vercel/workpath0/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/vercel/workpath0/node_modules/@babel/runtime/helpers/getPrototypeOf");

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var TruffleError = require("@truffle/error");

var utils = require("./utils");

var defaultGas = 90000;

var StatusError = /*#__PURE__*/function (_TruffleError) {
  "use strict";

  _inherits(StatusError, _TruffleError);

  var _super = _createSuper(StatusError);

  function StatusError(args, tx, receipt, reason) {
    var _this;

    _classCallCheck(this, StatusError);

    var message;
    var gasLimit = args.gas || defaultGas;
    var reasonString = "";
    if (reason) reasonString = "Reason given: ".concat(reason, ".");

    if (utils.bigNumberify(receipt.gasUsed).eq(utils.bigNumberify(gasLimit))) {
      message = "Transaction: " + tx + " exited with an error (status 0) after consuming all gas.\n" + "     Please check that the transaction:\n" + "     - satisfies all conditions set by Solidity `assert` statements.\n" + "     - has enough gas to execute the full transaction.\n" + "     - does not trigger an invalid opcode by other means (ex: accessing an array out of bounds).";
    } else {
      message = "Transaction: ".concat(tx, " exited with an error (status 0). ").concat(reasonString, "\n") + "     Please check that the transaction:\n" + "     - satisfies all conditions set by Solidity `require` statements.\n" + "     - does not trigger a Solidity `revert` statement.\n";
    }

    _this = _super.call(this, message);
    _this.tx = tx;
    _this.receipt = receipt;
    _this.reason = reason;
    return _this;
  }

  return StatusError;
}(TruffleError);

module.exports = StatusError;